module.exports = __webpack_public_path__ + "fonts/ac9a922232bb34219e80325fd9385afd-Roboto-BlackItalic.woff";